import * as React from "react";
import { Box, Popover, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import LoginIcon from "@mui/icons-material/Login";

interface QuickActionsPopupProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onAddUser?: () => void;
  onAddRole?: () => void;
  onAddDept?: () => void;
  onAddItem?: () => void;
  onMoveItem?: () => void;
  onReceiveItem?: () => void;
  onAddOrder?: () => void;
  onAssignPackages?: () => void;
  onAddPincode?: () => void;
}

const QuickActionsPopup = ({anchorEl, onClose, onAddUser, onAddRole,onAddDept,onAddItem,onMoveItem,onReceiveItem,onAddOrder,onAssignPackages,onAddPincode}: QuickActionsPopupProps) => {
  const sections = [
    {
      title: "User Management",
      items: [
        { label: "Add User", icon: <AddIcon /> },
        { label: "Add Role", icon: <AddIcon /> },
        { label: "Add Department", icon: <AddIcon /> },
      ],
    },
    {
      title: "Inventory",
      items: [
        { label: "Add Items", icon: <AddIcon /> },
        { label: "Move Items", icon: <LogoutIcon /> },
        { label: "Receive Items", icon: <LoginIcon sx={{ transform: "scaleX(-1)" }} /> },
      ],
    },
    {
      title: "Order, Delivery",
      items: [
        { label: "Add order", icon: <AddIcon /> },
        { label: "Assign Packages", icon: <PersonIcon /> },
        { label: "Scan Container", icon: <Box component="img" src="/scan.svg" sx={{ width: 20, height: 20 }} /> },
      ],
    },
    {
      title: "Pins",
      items: [
        { label: "Add Delivery Pins", icon: <AddIcon /> },
      ],
    },
  ];

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{ mt: 1 }}
    >
      <Box sx={{ width: 800, p: 2 }}>
        <Box sx={{ display: "flex", gap: 3 }}>
          {sections.map((section, idx) => (
            <Box key={idx}>
              <Typography sx={{ fontSize: "18px", fontWeight: 700, mb: 1.5, color: "#000814" }}>
                {section.title}
              </Typography>
              {section.items.map((item, itemIdx) => (
                <Box
                  key={itemIdx}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    mb: 1,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (item.label === "Add User" && onAddUser) {
                      onAddUser();
                    } else if (item.label === "Add Role" && onAddRole) {
                      onAddRole();
                    }else if (item.label === "Add Department" && onAddDept){
                      onAddDept();
                    }else if (item.label === "Add Items" && onAddItem) {
                      onAddItem();
                    } else if (item.label === "Move Items" && onMoveItem) {
                      onMoveItem();
                    } else if (item.label === "Receive Items" && onReceiveItem) {
                      onReceiveItem();
                    } else if (item.label === "Add order" && onAddOrder) {
                      onAddOrder();
                    } else if (item.label === "Assign Packages" && onAssignPackages) {
                      onAssignPackages();
                    } else if (item.label === "Add Delivery Pins" && onAddPincode) {
                      onAddPincode();
                    }
                    onClose();
                  }}
                >
                  <Box sx={{
                    borderRadius: "8px",
                    background: "rgba(74, 85, 101, 0.10)",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#61708A",
                    "& svg": { fontSize: "16px" },
                  }}>
                    {item.icon}
                  </Box>
                  <Typography sx={{ fontSize: "14px", fontWeight: 400, lineHeight: "24px", color: "#000814" }}>
                    {item.label}
                  </Typography>
                </Box>
              ))}
            </Box>
          ))}
        </Box>
      </Box>
    </Popover>
  );
};

export default QuickActionsPopup;
